import { Button, Grid } from "@material-ui/core";
import CommonButton from "app/common/Component/Button/CommonButton";
import PopupForm from "app/common/Component/Popup/PopupForm";
import React from "react";
import * as yup from "yup";
import axios from "axios";
import ConstantList from "../../../appConfig";
import { toast } from "react-toastify";
import GlobitsTextPassword from "app/common/form/GlobitsTextPassword";

const ChangePasswordPopup = (props) => {
  const { open, handleClose } = props;

  const validationSchema = yup.object({
    oldPassword: yup
      .string()
      .nullable()
      .required("Bạn chưa nhập mật khẩu hiện tại"),

    password: yup
      .string()
      .nullable()
      .test("required", "Mật khẩu mới chưa nhập", (data) => {
        if (!!data) {
          return true;
        }
        return false;
      })
      .test("length", "Mật khẩu lớn hơn 5 kí tự", (data) => {
        if (data?.length > 5) {
          return true;
        }
        return false;
      })
      .test("uppercase", "Mật khẩu phải có chữ in hoa", (data) => {
        if (/[A-Z]/.test(data)) {
          return true;
        }
        return false;
      })
      .test("digits", "Mật khẩu phải có chữ số", (data) => {
        if (/[0-9]/.test(data)) {
          return true;
        }
        return false;
      })
      .test("characters", "Mật khẩu phải có ký tự đặc biệt", (data) => {
        if (/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(data)) {
          return true;
        }
        return false;
      }),

    confirmPassword: yup
      .string()
      .nullable()
      .test("confirmPass", "Mật khẩu không trùng", function (data) {
        const parent = this.parent;
        if (data !== parent.newPassword) {
          return true;
        }
        return false;
      }),
  });

  return (
    <PopupForm
      title={"Thay đổi mật khẩu"}
      open={open}
      size={"sm"}
      handleClose={handleClose}
      formik={{
        initialValues: {
          password: "",
          confirmPassword: "",
          oldPassword: "",
        },
        enableReinitialize: true,
        onSubmit: async (values) => {
          try {
            const { data } = await axios.post(ConstantList.API_EN_POINT + "/user-ext/change-password", values);
            if (data?.responseStatus === 1) {
              toast.success("Đổi mật khẩu thành công");
            } else {
              toast.success(data?.message);
            }
          } catch (error) {
            toast.error("Đổi mật khẩu thất bại");
          }
        },
        validationSchema: validationSchema,
      }}
      action={
        <>
          <Button className="btn-orange ml-2" type="submit">
            Lưu
          </Button>

          <CommonButton
            className="btn-gray"
            variant="contained"
            onClick={handleClose}
          >
            Hủy
          </CommonButton>
        </>
      }
    >
      {({ setFieldValue, values }) => {
        return (
          <>
            <Grid
              container
              spacing={1}
              component={"section"}
              className="cards-container"
            >
              <Grid item xs={12}>
                <GlobitsTextPassword
                  name="oldPassword"
                  label="Mật khẩu hiện tại"
                />
              </Grid>
              <Grid item xs={12}>
                <GlobitsTextPassword
                  name="password"
                  type="password"
                  label="Mật khẩu mới"
                  description="Mật khẩu cần trên 6 kí tự, có chữ in hoa, số và kí tự đặc biệt"
                />
              </Grid>
              <Grid item xs={12}>
                <GlobitsTextPassword
                  name="confirmPassword"
                  type="password"
                  label="Nhập lại mật khẩu mới"
                />
              </Grid>
            </Grid>
          </>
        );
      }}
    </PopupForm>
  );
};

export default ChangePasswordPopup;
